import Vue from 'vue'
import App from './App.vue'
import i18n from './lang/index.js';
//使用element-ui
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
//引入cookies
import Cookies from 'js-cookie'
Vue.prototype.$cookie = Cookies;
//引入全局scss
import '@/assets/styles/template.scss';
//引入方法
//时间过滤
import filter from '@/utils/filter/data'
Vue.prototype.$formatTimestamp = filter.formatTimestamp;
//引入store
import store from './store/index.js';
//引入router
import VueRouter from 'vue-router'
import router from './router/index.js';
import '@/assets/js/flexible.js';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ElementUI);
//全局注册组件
import Component from '@/utils/index.js'
Vue.use(Component)
//引入API
import API from '@/request/api.js';
Vue.prototype.$api = API;
//全局变量域名
// let httpurl = "https://bgjk.jxdinfen.com"
// Vue.prototype.imgurl = httpurl;
// Vue.prototype.uploadimg = httpurl + "/api/admin/index/uploadfile"
// Vue.prototype.uploadfile = httpurl + "/api/admin/index/uploadfile"

//全局过滤器 秒
Vue.filter('formatTimestamp', filter.formatTimestamp)

new Vue({
  i18n,
  router,
  store: store,  //或者直接写store
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this; //创建全局事件总线
  }
}).$mount('#app')
